module.exports = __webpack_public_path__ + "static/img/1.3b987de.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/sp/1.png
// module id = YOYK
// module chunks = 0